<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Editar producto</p>
              </div>
            </div>
            <div class="card-body">
                <form @submit.prevent="submitProduct">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-control-label">Código</label>
                        <argon-input v-model="product.code" type="text" />
                        <small v-if="submitted && v$.product.code.$error" class="text-danger">Código requerido</small>
                    </div>
                    <div class="col-md-6">
                        <label class="form-control-label">Nombre</label>
                        <argon-input v-model="product.name" type="text" />
                        <small v-if="submitted && v$.product.name.$error" class="text-danger">Nombre requerido</small>
                    </div>
                    <div class="col-md-4">
                        <label class="form-control-label">Tasa mínima (%)</label>
                        <argon-input v-model="product.min_rate" type="number" step="0.01" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-control-label">Tasa máxima (%)</label>
                        <argon-input v-model="product.max_rate" type="number" step="0.01" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-control-label">Tasa por defecto (%)</label>
                        <argon-input v-model="product.default_rate" type="number" step="0.01" />
                    </div>
                    <div class="col-md-6">
                        <label class="form-control-label">Monto mínimo</label>
                        <argon-input v-model="product.min_amount" type="number" step="0.01" />
                    </div>
                    <div class="col-md-6">
                        <label class="form-control-label">Monto máximo</label>
                        <argon-input v-model="product.max_amount" type="number" step="0.01" />
                    </div>
                    <div class="col-md-12">
                        <div class="table-responsive p-0">
                            <label for="example-text-input" class="form-control-label"
                            >CARGOS</label
                            >
                            <table class="table align-items-center mb-0">
                            <thead>
                                <tr>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Codigo</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tasa</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Aplicado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in expenses" :key="index">
                                <td>{{ item.code }}</td>
                                <td>{{ item.name }}</td>
                                <td class="text-end">{{ item.rate||0}}</td>
                                <td class="text-end">{{ (item.amount||0)}}</td>
                                <td class="text-end">
                                    <span v-if="item.type === 1" >Seguro</span>
                                    <span v-if="item.type === 2" >Administrativo</span>
                                    <span v-if="item.type === 3" >Comisión</span>
                                    <span v-if="item.type === 4" >OTros</span>
                                </td>
                                <td class="text-end">
                                    <span v-if="item.aplyed === 1" >Desembolso</span>
                                    <span v-if="item.aplyed === 2" >Cuota</span>
                                </td>
                               
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <argon-button
                  type="submit"
                  class="mt-4"
                  color="success"
                  fullWidth
                  size="lg"
                >Guardar</argon-button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import axios from "axios";

export default {
  name: "ProductForm",
  components: { ArgonInput, ArgonButton },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      submitted: false,
      product: {
        code: '',
        name: '',
        company_id:1,
        min_rate: 0.00,
        max_rate: 0.00,
        default_rate: 0.00,
        min_amount: 0.00,
        max_amount: 0.00
      },
      expenses:[]
    };
  },
  validations() {
    return {
      product: {
        code: { required },
        name: { required }
      }
    };
  },
    methods: {
        async fetchExpenses(config){
            let self=this;
            fetch(this.$store.state.apiURL+'list/product_expenses/?product_id='+this.$route.params.id, config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.expenses=result.product_expenses;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },

        async fetch(config){
            let self=this;
            fetch(this.$store.state.apiURL+'view/products/'+this.$route.params.id, config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.product=result.products;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        submitProduct() {
            this.submitted = true;
            this.v$.$touch();
            if (!this.v$.$invalid) {
                const token = localStorage.getItem("accessToken");
                const config = { headers: { "X-Authorization": `Bearer ${token}` } };

                axios.post(this.$store.state.apiURL + 'edit/products/'+this.$route.params.id, this.product, config)
                .then(() => {
                    this.$swal({
                    title: 'Producto creado',
                    text: 'El producto fue registrado correctamente.',
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                    }).then(() => {
                    this.$router.push('/products');
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$swal({
                    title: 'Error',
                    text: 'No se pudo guardar el producto.',
                    icon: 'error',
                    confirmButtonColor: '#0b9257'
                    });
                });
            } else {
                this.$swal({
                title: 'Datos inválidos',
                text: 'Por favor, revisa los campos requeridos.',
                icon: 'warning',
                confirmButtonColor: '#0b9257'
                });
            }
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetch(config);
        this.fetchExpenses(config);
        //this.fetchClientData(config);
        //this.fetchTestTypes(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>
  